// extracted by mini-css-extract-plugin
export var buttonContent = "_3o-0";
export var centered = "_3o-1";
export var centeredFlex = "_3o-2";
export var errorText = "_3o-3";
export var icon = "_3o-4";
export var iconButtonContent = "_3o-5";
export var monospace = "_3o-6";
export var padded = "_3o-7";